// import { useState } from 'react';
import { FileX2 } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

import DocumentRow from '@/app/document/components/DocumentRow';

const CertificationRow = ({ certification }) => {
  // const [open, setIsOpen] = useState(false);

  const { documents } = certification;

  if (!certification.name) {
    return (
      <Alert>
        <FileX2 className="h-4 w-4" />
        <AlertTitle>No Qualifications Found</AlertTitle>
        <AlertDescription>
          The coach has not input any qualifications.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <>
      <div key={certification.id} className="flex flex-col gap-2">
        <h4 className="inline-block font-bold text-sm">
          {certification.name}:
        </h4>
        <div className="pl-6">
          {documents.map((document) => (
            <DocumentRow document={document} key={document.id} />
          ))}
        </div>
      </div>
      {/* {open && (
        <ViewDialog document={documents[0]} open={open} setIsOpen={setIsOpen} />
      )} */}
    </>
  );
};

export default CertificationRow;
